export const UPI_APPS = [
    { label: 'PhonePe', src: '/images/phonepe-icon.png' },
    { label: 'GPay', src: '/images/google-pay-icon (1).png' },
    { label: 'Paytm', src: '/images/Paytm_logo (1).png' },
    { label: 'BHIM', src: '/images/bhim-upi (1).png' },
    { label: 'WhatsApp', src: '/images/WhatsApp_icon (2).png' },
] as const

const readUpiParam = (intentString: string, key: string): string => {
    if (!intentString) return ''
    try {
        const query = intentString.includes('?') ? intentString.slice(intentString.indexOf('?') + 1) : intentString
        return new URLSearchParams(query).get(key) ?? ''
    } catch {
        return ''
    }
}

/** Pull `am` from a `upi://pay?...` intent string. */
export const readAmountFromUpiIntent = (intentString: string): string => readUpiParam(intentString, 'am')

export const readVpaFromUpiIntent = (intentString: string): string => readUpiParam(intentString, 'pa')
